import { SHIFTTYPE } from "./types";

import ActionHelper from "../helpers/ActionHelper";

export const createShiftType = (form) => (dispatch) => {
  return ActionHelper.requestServer(
    "POST",
    "/shifttype",
    form,
    SHIFTTYPE.SHIFTTYPE_CREATE_REQUEST,
    SHIFTTYPE.SHIFTTYPE_CREATE_SUCCESS,
    SHIFTTYPE.SHIFTTYPE_CREATE_FAIL,
    dispatch,
  );
};

export const getShiftTypes = (companies) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    `/shifttype?companies=${companies}`,
    null,
    SHIFTTYPE.SHIFTTYPE_GET_SHIFTTYPES_REQUEST,
    SHIFTTYPE.SHIFTTYPE_GET_SHIFTTYPES_SUCCESS,
    SHIFTTYPE.SHIFTTYPE_GET_SHIFTTYPES_FAIL,
    dispatch,
  );
};

export const getShiftType = (id) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    "/shifttype/" + id,
    null,
    SHIFTTYPE.SHIFTTYPE_GET_REQUEST,
    SHIFTTYPE.SHIFTTYPE_GET_SUCCESS,
    SHIFTTYPE.SHIFTTYPE_GET_FAIL,
    dispatch,
  );
};

export const updateShiftType = (id, form) => (dispatch) => {
  return ActionHelper.requestServer(
    "PUT",
    "/shifttype/" + id,
    form,
    SHIFTTYPE.SHIFTTYPE_UPDATE_REQUEST,
    SHIFTTYPE.SHIFTTYPE_UPDATE_SUCCESS,
    SHIFTTYPE.SHIFTTYPE_UPDATE_FAIL,
    dispatch,
  );
};

export const deleteShiftType = (id) => (dispatch) => {
  return ActionHelper.requestServer(
    "DELETE",
    "/shifttype/" + id,
    null,
    SHIFTTYPE.SHIFTTYPE_DELETE_REQUEST,
    SHIFTTYPE.SHIFTTYPE_DELETE_SUCCESS,
    SHIFTTYPE.SHIFTTYPE_DELETE_FAIL,
    dispatch,
  );
};



// WEBPACK FOOTER //
// ./src/actions/shiftTypeActions.js